<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">Penalties</h1>
      </template>
      <template #actions>
        <page-header-action tag="router-link" to="/penalties/create">
          Add Penalty
        </page-header-action>
      </template>
    </page-header>
    <div class="card mb-3">
      <div class="loading-overlay" v-if="loading"></div>
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Claim Reference</th>
              <th>Issuing Authority</th>
              <th>External Reference</th>
              <th>Type</th>
              <th>Vehicle</th>
              <th>Penalty Paid Date</th>
              <th>Settled Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-bind:key="index" v-for="(penalty, index) in penalties">
              <td>{{ penalty.hire?.incident?.source?.claim_reference }}</td>
              <td>{{ penalty.issuing_authority?.name || 'Not Available' }}</td>
              <td>{{ penalty.external_reference || 'Not Available' }}</td>
              <td>{{ penalty.penalty_type?.label || 'Not Available' }}</td>
              <td>{{ penalty.vehicle?.registration || 'Not Available' }}</td>
              <td>{{ penalty.penalty_paid_at | date }}</td>
              <td>{{ penalty.settled_date | date }}</td>
              <td>
                <router-link
                  class="btn btn-primary"
                  :to="`/penalties/${penalty.identifier}/edit`"
                >
                  Edit
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer text-right">
        <pagination
          :data="paginator_data"
          v-on:updateResults="getData"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from './../Shared/PageHeader.vue';
import PageHeaderAction from './../Shared/PageHeaderAction.vue';

export default {
  components: {
    PageHeader,
    PageHeaderAction
  },

  data() {
    return {
      penalties: [],
      paginator_data: {},
      filters: {},
      loading: true,
      indicator: false
    };
  },

  mounted() {
    this.loadFleet();
  },

  methods: {
    loadFleet() {
      this.getData(`/penalties?per_page=${this.perPage}`);
    },

    getData(url) {
      this.loading = true;

      Object.keys(this.filters).forEach(key => {
        url = `${url}&filter[${key}]=${this.filters[key]}`;
      });

      window.Ajax.get(`${url}&parts=hire,issuingAuthority,penaltyType,vehicle`)
        .then(response => {
          this.loading = false;
          this.penalties = response.data.data;
          this.paginator_data = response.data;
        })
        .catch(err => {});
    }
  }
};
</script>
